// src/components/Footer.js
import { FaXTwitter } from "react-icons/fa6"; // Import the X icon from react-icons
import { SiLinkedin, SiInstagram } from "react-icons/si";
import { Link } from "react-router-dom";

export default function Footer() {
    const footerNavigation = {
      solutions: [
  { name: 'Design Simulation of Quantum Dots', href: '/solutions/design-simulation-quantum-dots' },
  { name: 'AI Middleware for Tuning', href: '/solutions/ai-middleware-for-tuning' },
  { name: 'Automated Calibration and Control', href: '/solutions/automated-calibration-control' },
  { name: 'Quantum Skin for Intelligent Infrastructure', href: '/solutions/quantum-skin-for-intelligent-infra' },
  // { name: 'Seamless API Integrations', href: '/solutions/seamless-api-integration' },
  // { name: 'Advanced GPS & AI Features', href: '/solutions/advance-gps-tracking' },
  // { name: 'AI Driven Businesses', href: '/solutions/ai-driven' },
  // { name: 'Generative AI for Audio processing and Automation', href: '/solutions/genai-and-automation' },
],
      support: [
        // { name: 'Pricing', href: '#' },
        { name: 'Documentation', href: '/support/documentation' },
        { name: 'Customer Support', href: '/support/customer-support' },
        { name: 'API Status', href: '/support/api-status' },
        { name: 'Integrations', href: '/support/integrations' },
      ],
      company: [
        { name: 'About Us', href: '/aboutus' },
        { name: 'Our Team', href: '/aboutus/our-team' },
        { name: 'Contact Us', href: '/contact' },
        // { name: 'Press', href: '#' },
        { name: 'Partners', href: '/aboutus/partners' },
      ],
      legal: [
        { name: 'Report an Issue', href: '/support/report-an-issue' },
        { name: 'Privacy Policy', href: '/support/privacy-policy' },
        { name: 'Terms & Conditions', href: '/support/terms-and-conditions' },
        { name: 'Legal Support', href: '/support/legal-support' },
      ],
      blog: [
        { 
          name: 'AI-Driven Innovations in 2025', 
          href: '/blogs/ai-diven-innovation', 
          date: 'feb 1', 
          readTime: '8min read' 
        },
        { 
          name: 'How GPS Technology is Transforming Logistics', 
          href: '/blogs/gps-transforming-logistics', 
          date: 'feb 25', 
          readTime: '3min read', 
          featured: true 
        },
        { 
          name: 'Scaling Your Business with AI Automation', 
          href: '/blogs/scaling-business-with-ai', 
          date: 'march 19', 
          readTime: '2min read' 
        },
        { 
          name: 'Why Product Reliability Matters', 
          href: '/blogs/product-reliability-matters', 
          date: 'april 15', 
          readTime: '10min read' 
        },
      ],      
      social: [
        // {
        //   name: 'Instagram', 
        //   href: 'https://www.instagram.com/genxz_ai/',
        //   icon: (props) => <SiInstagram {...props} />, // Replace the SVG with FaXTwitter component
        // },
        {
          name: 'LinkedIn', 
          href: 'https://www.linkedin.com/company/genxzai/?viewAsMember=true',
          icon: (props) => <SiLinkedin {...props} />, // Replace the SVG with FaXTwitter component
        },

        {
          name: 'X', // Change name from 'Twitter' to 'X'
          href: 'https://x.com/GenXzai64073',
          icon: (props) => <FaXTwitter {...props} />, // Replace the SVG with FaXTwitter component
        },
       
    // {
    //   name: 'Facebook', 
    //   href: '#',
    //   icon: (props) => <FaFacebookSquare {...props} />, // Replace the SVG with FaXTwitter component
    // }, 
    
    // {
    //   name: 'GitHub',
    //   href: '#',
    //   icon: (props) => (
    //     <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
    //       <path
    //         fillRule="evenodd"
    //         d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
    //         clipRule="evenodd"
    //       />
    //     </svg>
    //   ),
    // },
    
        // Add other social links similarly
      ],
    };
  
    return (
      <footer className="bg-gray-50" aria-labelledby="footer-heading">
        <h2 id="footer-heading" className="sr-only">
          Footer
        </h2>
        <div className="max-w-7xl mx-auto pt-16 pb-8 px-4 sm:px-6 lg:pt-24 lg:px-8">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            <div className="grid grid-cols-2 gap-8 xl:col-span-2">
              <div className="md:grid md:grid-cols-2 md:gap-8">
                <div>
                  <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">Solutions</h3>
                  <ul className="mt-4 space-y-4">
                    {footerNavigation.solutions.map((item) => (
                      <li key={item.name}>
                        <Link to={item.href} className="text-base text-gray-500 hover:text-gray-900">
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mt-12 md:mt-0">
                  <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">Support</h3>
                  <ul className="mt-4 space-y-4">
                    {footerNavigation.support.map((item) => (
                      <li key={item.name}>
                        <Link to={item.href} className="text-base text-gray-500 hover:text-gray-900">
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="md:grid md:grid-cols-2 md:gap-8">
                <div>
                  <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">Company</h3>
                  <ul className="mt-4 space-y-4">
                    {footerNavigation.company.map((item) => (
                      <li key={item.name}>
                        <Link to={item.href} className="text-base text-gray-500 hover:text-gray-900">
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="mt-12 md:mt-0">
                  <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">Support & Policies</h3>
                  <ul className="mt-4 space-y-4">
                    {footerNavigation.legal.map((item) => (
                      <li key={item.name}>
                        <Link to={item.href} className="text-base text-gray-500 hover:text-gray-900">
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="xl:space-x-8 mt-12 xl:mt-0 md:grid md:gap-2">
              <h3 className="xl:ml-8 text-sm font-semibold text-gray-400 tracking-wider uppercase">FROM THE BLOG</h3>
              <ul className="xl:mt-0 mt-4 space-y-4">
                {footerNavigation.blog.map((item) => (
                  <li key={item.name}>
                    <Link to={item.href} className="text-base text-gray-500 hover:text-gray-900">
                      <div className="flex items-center">
                        <span>{item.name}</span>
                        {item.featured && (
                          <span className="ml-2 text-yellow-500">★</span>
                        )}
                      </div>
                      <div className="text-sm text-gray-400">
                        {item.date} • {item.readTime}
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* <div className="mt-12 xl:mt-0">
              <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
                CONNECT WITH US
              </h3>
              <p className="mt-4 text-base text-gray-500">
                Reach Out With Email!
              </p>
              <form className="mt-4 sm:flex sm:max-w-md">
                <label htmlFor="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  type="email"
                  name="email-address"
                  id="email-address"
                  autoComplete="email"
                  required
                  className="appearance-none min-w-0 w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-4 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:placeholder-gray-400"
                  placeholder="Enter your email"
                />
                <div className="mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                  <button
                    type="submit"
                    className="w-full flex items-center justify-center bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white hover:from-purple-700 hover:to-indigo-700"
                  >
                    Connect
                  </button>
                </div>
              </form>
            </div> */}
          </div>
          <div className="mt-12 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-between lg:mt-16">
            <div className="flex space-x-6 md:order-2">
              {footerNavigation.social.map((item) => (
                <Link key={item.name} to={item.href} className="text-gray-400 hover:text-gray-500">
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" />
                </Link>
              ))}
            </div>
            <p className="mt-8 text-base text-gray-400 md:mt-0 md:order-1">
              &copy; {new Date().getFullYear()} Genxz Software Pvt Ltd. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    );
  }
  